import { render } from "./EditModal.vue?vue&type=template&id=5dccc144&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"

import "./EditModal.vue?vue&type=style&index=0&id=5dccc144&lang=css"
import "./EditModal.vue?vue&type=style&index=1&id=5dccc144&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dccc144"]])

export default __exports__